// React import not required with the JSX runtime
import { useDevAuth } from '@core/auth/dev'
import AppRoutes from './router'

export default function App() {
  // Solo en desarrollo: simular autenticación
  useDevAuth()

  return <AppRoutes />
}

